import { styled } from "theme/default/styled";
import { setFontSize_15px } from "theme/setter/setFontSizeValues/setFontSize_15px";
import { setFontWeight400 } from "theme/setter/setFontWeightValues/setFontWeight400";
import { setColor_rgba_0_0_0_87 } from "theme/setter/setOpacityColorsValues/setColor_rgba_0_0_0_87";

export const SUserResetPasswordFormTitle = styled.div`
  ${setFontSize_15px};
  ${setFontWeight400};
  ${setColor_rgba_0_0_0_87};
`;
